import React from 'react';
import WrapperSection from '../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import BrandsTable from '../../components/brands/BrandsTable';

const Brands = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <BrandsTable />
        </WrapperSection>
    );
};

export default Brands;
